export default "__VITE_ASSET__DqVTneuD__"